import { render, staticRenderFns } from "./kChart.vue?vue&type=template&id=38f635c7&scoped=true&"
import script from "./kChart.vue?vue&type=script&lang=js&"
export * from "./kChart.vue?vue&type=script&lang=js&"
import style0 from "./kChart.vue?vue&type=style&index=0&id=38f635c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f635c7",
  null
  
)

export default component.exports